import React, { useState, useEffect } from 'react';
import {
  Button,
  Grid,
  Typography,
  Box,
  Card,
  CardContent,
  FormControlLabel,
  Checkbox,
  FormHelperText,
  Link,
} from '@mui/material';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import {
  AccountCircle,
  Email,
  Phone,
  LocationOn,
  Home,
  Password,
  AssignmentInd,
} from '@mui/icons-material';
import '../../styles/UserStyles.css';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import '../../styles/AddCustomer.css';
import { useDispatch, useSelector } from 'react-redux';
import { CUSTOMERS, VERIFY_OTP } from '../../component/common/Routes/AppRoutes';
import ControlledTextInputField from '../../component/ui/FormFields/ControlledTextInputField';
import CustomButton from '../../component/ui/FormFields/Button';
import {
  addCustomerRequest,
  resetCustomerState,
} from '../../redux/Customers/actions/customerActions';
import {
  selectCityRequest,
  selectCountryRequest,
  selectStateRequest,
} from '../../redux/Common/selectorAction';
import { addUserRequest, resetUserState } from '../../redux/User/UserAction';
import PasswordInput from '../../component/ui/PasswordInput';
import TopBar from '../../component/common/components/TopBar';
import Footer from '../../component/common/components/Footer';
import { convertDateFormatBooking } from '../../Style';

export default function CustomerRegistration() {
  const {
    handleSubmit,
    control,
    formState: { errors },
    setError,
    watch,
    setValue,
    clearErrors,
    register,
  } = useForm({ defaultValues: {}, mode: 'onChange' });
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(selectCountryRequest());
  }, []);

  const formValue = watch();
  const countryId = formValue.country?.value;
  const stateId = formValue.state?.value;

  const countries = useSelector((state) => state.selector?.country?.data);
  const states = useSelector((state) => state.selector?.state?.data);
  const cities = useSelector((state) => state.selector?.city?.data);
  const countryForCode = countries?.map((value) => {
    return {
      label: ` +${value.phonecode} - ${value.short_name}`,
      value: value.phonecode,
    };
  });
  const countryName = countries?.map((country) => {
    return { value: country?.id, label: country?.country_name };
  });
  const stateName = states?.map((state) => {
    return { value: state?.id, label: state?.state_name };
  });
  const cityName = cities?.map((city) => {
    return { value: city?.id, label: city?.city_name };
  });

  useEffect(() => {
    if (countryId > 0) {
      setValue('state', '');
      setValue('city', '');
      dispatch(selectStateRequest(countryId));
    }
  }, [countryId]);

  useEffect(() => {
    if (stateId > 0) {
      setValue('city', '');
      dispatch(selectCityRequest(stateId));
    }
  }, [stateId]);
  const passportNumber = watch('passport_number');
  const aadharNumber = watch('aadhar_number');
  const success = useSelector((state) => state.user.success || false);
  const loading = useSelector((state) => state.user?.loading);
  const error = useSelector((state) => state.user.error);
  const validateIdentityDocument = () => {
    return (
      (passportNumber && passportNumber.trim() !== '') ||
      (aadharNumber && aadharNumber.trim() !== '') ||
      'Either Passport Number or Aadhar Number is required'
    );
  };
  const customerFields = [
    {
      name: 'first_name',
      label: 'First Name (If Company, Enter Company Details) *',
      placeholder: 'Enter First Name',
      icon: <AccountCircle />,
      rules: { required: 'First Name is required' },
      sm: 6,
      xs: 12,
    },
    {
      name: 'last_name',
      label: 'Last Name ',
      placeholder: 'Enter Last Name',
      icon: <AccountCircle />,

      sm: 6,
      xs: 12,
    },
    {
      name: 'dob',
      label: 'Date of Birth (For Companies, Enter a Dummy Date Above Age 12 )*',
      placeholder: 'Select date of birth',
      type: 'dob',
      rules: { required: 'Date of Birth is required' },
      xs: 12,
      sm: 6,
    },
    {
      name: 'email',
      label: 'Email *',
      placeholder: 'Enter Email Address',
      icon: <Email />,
      rules: {
        required: 'Email Address is required',
        pattern: {
          value: /^\S+@\S+\.\S+$/,
          message: 'Enter a valid email address',
        },
      },
      sm: 6,
      xs: 12,
    },
    {
      name: 'password',
      label: 'Password *',
      placeholder: 'Enter password',
      icon: <Password />,
      component: PasswordInput,
      sm: 6,
      xs: 12,
    },
    {
      name: 'country_code',
      options: countryForCode,
      label: 'Country Code *',
      placeholder: 'Select Country Code',
      rules: {
        required: 'Code is Required',
      },
      sm: 2,
      xs: 4,
    },
    {
      name: 'phone',
      label: 'Mobile No *',
      placeholder: 'Enter Mobile Number',
      type: 'Number',
      icon: <Phone />,
      rules: {
        required: 'Mobile Number is required',
        pattern: {
          value: /^\d+$/,
          message: 'Enter only numeric digits',
        },
      },
      sm: 4,
      xs: 8,
    },
    {
      name: 'address1',
      label: 'Address 1 *',
      placeholder: 'Enter Address',
      icon: <Home />,
      rules: { required: 'Address is required' },
      sm: 6,
      xs: 12,
    },

    {
      name: 'address2',
      label: 'Address 2',
      placeholder: 'Enter Address',
      icon: <Home />,
      // rules: { required: "Address is required" },
      sm: 6,
      xs: 12,
    },
    {
      name: 'nationality',
      label: 'Nationality *',
      placeholder: 'Enter Nationality',
      type: 'text',
      rules: {
        required: 'Nationality is required',
        pattern: {
          value: /^[A-Za-z\s]+$/,
          message: 'Only alphabets are allowed',
        },
      },
      xs: 12,
      sm: 6,
      inputProps: {
        onInput: (e) => {
          e.target.value = e.target.value.replace(/[^A-Za-z\s]/g, '');
        },
      },
    },
    {
      name: 'country',
      label: 'Country *',
      placeholder: 'Enter Country',
      icon: <LocationOn />,
      rules: { required: 'Country is required' },
      options: countryName,
      sm: 6,
      xs: 12,
    },

    {
      name: 'state',
      label: 'State *',
      placeholder: 'Enter State',
      icon: <LocationOn />,
      rules: { required: 'State is required' },
      options: stateName,
      sm: 6,
      xs: 12,
    },
    {
      name: 'city',
      label: 'City *',
      placeholder: 'Enter City',
      icon: <LocationOn />,
      rules: { required: 'City is required' },
      options: cityName,
      sm: 6,
      xs: 12,
    },
    {
      name: 'pincode',
      label: 'Pincode *',
      placeholder: 'Enter Pincode',
      icon: <LocationOn />,
      type: 'Number',
      rules: {
        required: 'Pincode is required',
        pattern: {
          value: /^[0-9]+$/,
          message: 'Enter a valid numeric pincode',
        },
      },
      sm: 6,
      xs: 12,
    },

    {
      name: 'passport_number',
      label: 'Passport Number',
      placeholder: 'Enter Passport Number',
      rules: {
        validate: {
          // identityRequired: validateIdentityDocument,
          passportFormat: (value) => {
            if (!value || value.trim() === '') return true;

            const patterns = {
              US: /^[0-9]{9}$/,
              UK: /^[0-9]{9}$|^[A-Z]{2}[0-9]{7}$/,
              EU: /^[A-Z]{1,2}[0-9]{5,7}$/,
              CA: /^[A-Z]{2}[0-9]{6}$/,
              AU: /^[A-Z][0-9]{8}$/,
              IN: /^[A-Z][0-9]{7}$/,
              general: /^[A-Z0-9]{5,12}$/i,
            };

            return (
              patterns.US.test(value) ||
              patterns.UK.test(value) ||
              patterns.EU.test(value) ||
              patterns.CA.test(value) ||
              patterns.AU.test(value) ||
              patterns.IN.test(value) ||
              patterns.general.test(value) ||
              'Please enter a valid passport number'
            );
          },
        },
      },
      xs: 12,
      sm: 6,
    },
    {
      name: 'aadhar_number',
      label: 'Aadhar Number',
      placeholder: 'Enter Aadhar Number',
      type: 'Number',
      rules: {
        validate: {
          // identityRequired: validateIdentityDocument,
          aadharFormat: (value) => {
            if (!value || value.trim() === '') return true;

            return (
              /^\d{12}$/.test(value) ||
              'Aadhar Number must be exactly 12 digits'
            );
          },
        },
      },
      xs: 12,
      sm: 6,
    },
      {
  name: 'pan_number',
  label: 'PAN Number',
  type: 'text',
  rules: {
    required: false, // <-- explicitly optional
    validate: (value) => {
      if (value) {
        const validFormat = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(value); 
        if (!validFormat) {
          return 'Invalid PAN format (e.g., ABCDE1234F)';
        }
      }
      return true;
    },
  },
  sm: 6,
  xs: 12,
},
{
  name: 'customer_gst_no',
  label: 'GST Number',
  type: 'text',
  rules: {
    required: false, // <-- explicitly optional
    validate: (value) => {
      if (value) {
        const validFormat = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/.test(value);
        if (!validFormat) {
          return 'Invalid GSTIN format (e.g., 22ABCDE1234F1Z5)';
        }
      }
      return true;
    },
  },
  sm: 6,
  xs: 12,
},
    {
      name: 'gender_type',
      label: 'Gender',
      placeholder: 'Select Gender',
      icon: <AssignmentInd />,
      type: 'radio',
      radioOptions: [
        { value: 'M', label: 'Male' },
        { value: 'F', label: 'Female' },
        { value: 'O', label: 'Other' },
      ],
      rules: { required: 'Gender is required' },
      sm: 6,
      xs: 12,
    },
  ];

  useEffect(() => {
    if (success) {
      localStorage.setItem('userEmail', watch('email'));
      toast.success('Registered Successfully!', {
        position: 'top-center',
        autoClose: 3000,

        onClose: () => {
          dispatch(resetUserState());
          navigate(VERIFY_OTP);
        },
      });
    }

    if (error) {
      if (error.message === 'Email must be unique') {
        setError('email', {
          type: 'server',
          message: 'Email must be unique',
        });
      }
      if (error.message === 'Contact must be unique') {
        setError('phone', {
          type: 'server',
          message: 'Contact must be unique',
        });
      }
    }
  }, [success, error, navigate, dispatch, setError]);

  const onSubmit = (data) => {
    clearErrors();

    // if (formValue?.aadhar_number === "" && formValue?.passport_number === "") {
    //   setError("aadhar_number", {
    //     type: "server",
    //     message: "Aadhar or Passport Number is needed",
    //   });
    //   setError("passport_number", {
    //     type: "server",
    //     message: "Aadhar or Passport Number is needed",
    //   });
    //   return;
    // }

    const customerData = {
      first_name: data.first_name,
      last_name: data.last_name,
      display_name: `${data.first_name} ${data.last_name}`,
      email: data.email,
      password: data.password,
      phone: data.phone,
      address1: data.address1,
      address2: data.address2,
      city: data.city?.value || data.city,
      state: data.state?.value || data.state,
      country: data.country?.value || data.country,
      pincode: data.pincode,
      profile_url: null,
      user_type: '3',
      role_id: '',
      agency_name: '',
      pan_number:data.pan_number|| '',
      customer_gst_no: data.customer_gst_no||'',
      
      country_code: data.country_code?.value,
      passport_number: data?.passport_number,
      aadhar_number: data?.aadhar_number,
      nationality: data?.nationality,
      type: '3',
      dob: convertDateFormatBooking(data?.dob),
      gender_type: data?.gender_type,
    };

    dispatch(addUserRequest(customerData));
  };
  return (
    <>
      <TopBar unAuth={true} />
      <Box className='container'>
        <Card sx={{ marginTop: '100px' }}>
          <CardContent className='card'>
            <Typography variant='h5' className='form-heading'>
              Customer Registration
            </Typography>
            <form onSubmit={handleSubmit(onSubmit)}>
              <Grid
                className='customer-form-margin'
                container
                rowSpacing={4}
                columnSpacing={{ xs: 1, sm: 1, md: 1, lg: 3 }}
              >
                {customerFields.map((field, index) => (
                  <Grid item xs={field.xs} sm={field.sm} key={index}>
                    {field.component ? (
                      <field.component
                        name={field.name}
                        control={control}
                        label={field.label}
                        placeholder={field.placeholder}
                        startAdornment={field.icon}
                        rules={field.rules}
                        error={!!errors[field.name]}
                        helperText={errors[field.name]?.message}
                      />
                    ) : (
                      <ControlledTextInputField
                        name={field.name}
                        control={control}
                        label={field.label}
                        options={field.options}
                        placeholder={field.placeholder}
                        startAdornment={field.icon}
                        type={field.type}
                        rules={field.rules}
                        radioOptions={field.radioOptions}
                        error={!!errors[field.name]}
                        helperText={errors[field.name]?.message}
                      />
                    )}
                  </Grid>
                ))}

                <Grid item xs={12}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        {...register('termsAccepted', {
                          required:
                            'You must accept the Terms and Privacy Policy to continue',
                        })}
                        color='primary'
                      />
                    }
                    label={
                      <Typography variant='body2'>
                        I agree to the{' '}
                        <Link
                          href='https://atithiairportseva.com/terms-and-conditions/'
                          target='_blank'
                        >
                          Terms and Conditions
                        </Link>{' '}
                        and{' '}
                        <Link
                          href='https://atithiairportseva.com/privacy-policy/'
                          target='_blank'
                        >
                          Privacy Policy
                        </Link>
                      </Typography>
                    }
                  />
                  {errors.termsAccepted && (
                    <FormHelperText error>
                      {errors.termsAccepted.message}
                    </FormHelperText>
                  )}
                </Grid>

                <Grid item xs={12}>
                  <Box className='button-container'>
                    <CustomButton
                      variant='contained'
                      className='success-button'
                      type='submit'
                      loading={loading}
                      text={'submit'}
                    />
                  </Box>
                </Grid>
              </Grid>
            </form>
            <ToastContainer />
          </CardContent>
        </Card>
      </Box>
      <Footer />
    </>
  );
}
